export const FORCED_MFA_ENROLLMENT_URL = '/account.html#security';

export function isAccountSecurityRoute(activeRoute: string): boolean {
  return activeRoute === 'account.html';
}
